// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import { IRoute } from '../';
import PrintReceipt from './PrintReceipt';

const printReceiptRoutes: IRoute[] = [
    {
        crumbText: 'Print Receipt',
        component: PrintReceipt,
        exact: true,
        path: '/printReceipt',
        public: true,
    },
];

export default printReceiptRoutes;
